export var ExpressionFunctions;
(function (ExpressionFunctions) {
    ExpressionFunctions["Time"] = "Time";
    ExpressionFunctions["Template"] = "Template";
    ExpressionFunctions["Constant"] = "Constant";
    ExpressionFunctions["Translate"] = "Translate";
    ExpressionFunctions["Conditional"] = "Conditional";
})(ExpressionFunctions || (ExpressionFunctions = {}));
//# sourceMappingURL=xmlConfig.js.map